import styled from "styled-components";

export const HeaderContainer = styled.div`
  background-color: var(--fd-colors-background-base);
`;

export const HeaderWrapper = styled.div<{ isMobile: boolean }>`
  background-color: var(--fd-colors-background-surface);
  padding: var(--fd-space-space-4) var(--fd-space-space-4) 0
    var(--fd-space-space-4);
  ${({ isMobile }) =>
    !isMobile &&
    `
      border-top-right-radius: var(--fd-radii-border-radius-020);
      border-top-left-radius: var(--fd-radii-border-radius-020);
    `}
`;
